import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberMaskingPipe } from '../pipe/number-masking.pipe';
import { NavComponent } from './nav/nav.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptorService } from '../services/loader-interceptor.service';
import { TimeoutInterceptorService, DEFAULT_TIMEOUT } from '../services/timeout-interceptor.service';
import { MatCardModule } from "@angular/material/card";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSliderModule } from '@angular/material/slider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { SafeHtmlPipe } from '../pipe/safe-html.pipe';
import {
  MatDialogModule,
  MAT_DIALOG_DEFAULT_OPTIONS
} from "@angular/material/dialog";
import { ErrorPageComponent } from './error-page/error-page.component';
import { HeadersectionComponent } from './headersection/headersection.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { MaskPipe } from '../pipe/mask.pipe';
import { SuccessPageComponent } from './success-page/success-page.component';
export const MaterialModuleArr = [
  MatCardModule,
  MatGridListModule,
  MatInputModule,
  MatRadioModule,
  MatSelectModule,
  MatCheckboxModule,
  MatButtonModule,
  MatChipsModule,
  MatDialogModule,
  MatStepperModule,
  MatIconModule,
  MatExpansionModule,
  MatSliderModule,
  MatDatepickerModule,
  MatTooltipModule,
  MatAutocompleteModule,
  MatSlideToggleModule
];
@NgModule({
  declarations: [
    NumberMaskingPipe,
    NavComponent,
    ErrorPageComponent,
    HeadersectionComponent,
    ProgressBarComponent,
    MaskPipe,
    SafeHtmlPipe,
    SuccessPageComponent

    
  ],
  imports: [
    CommonModule,
    ...MaterialModuleArr
  ],
  exports: [
    ...
    MaterialModuleArr,
    NumberMaskingPipe,
    NavComponent,
    ProgressBarComponent,
    SafeHtmlPipe,
    MaskPipe
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptorService, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoaderInterceptorService,
    multi: true
  },
  { provide: DEFAULT_TIMEOUT, useValue: 120000 },
  { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } }]
})
export class SharedModule { }
